export const CONTACT_TYPES = {
  SMS: "SMS",
  PHONE: "PHONE",
  EMAIL: "EMAIL",
};
